"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var barcode_png_1 = __importDefault(require("@hikakaku/shared/images/barcode_reader/barcode.png"));
var barcode_frame_png_1 = __importDefault(require("@hikakaku/shared/images/barcode_reader/barcode-frame.png"));
var get_device_type_1 = require("@hikakaku/shared/util/get_device_type");
var util_1 = __importDefault(require("@hikakaku/shared/util/util"));
var BarcodeReader = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store;
    var _b = (0, react_1.useState)(false), showsReader = _b[0], setShowsReader = _b[1];
    (0, react_1.useEffect)(function () {
        setShowsReader(util_1.default.isMobile());
    }, []);
    if (!showsReader)
        return null;
    return (store.active
        ? (react_1.default.createElement("div", { className: "estimateForm-BarcodeReader" },
            react_1.default.createElement("button", { onClick: store.handleClickCloseIcon, className: "estimateForm-BarcodeReader_CloseButton" },
                react_1.default.createElement("i", { className: "fa fa-times" })),
            react_1.default.createElement("div", { className: "estimateForm-BarcodeReader_VideoFrame" },
                react_1.default.createElement("video", { ref: store.videoRef, className: "estimateForm-BarcodeReader_Video" })),
            store.readerLabelText &&
                react_1.default.createElement("div", { className: store.readerLabelClassNames }, store.readerLabelText),
            react_1.default.createElement("img", { src: barcode_frame_png_1.default, alt: "barcodeFrameImage", className: "estimateForm-BarcodeReader_ReaderImage estimateForm-BarcodeReader_ReaderImage-frame lazyload" }),
            react_1.default.createElement("img", { src: barcode_png_1.default, alt: "barcodeImage", className: "estimateForm-BarcodeReader_ReaderImage estimateForm-BarcodeReader_ReaderImage-barcode lazyload" }))) : (react_1.default.createElement("div", { className: "estimateForm-BarcodeReader_StartButtonWrapper" },
        react_1.default.createElement("button", { onClick: store.handleClickStartButton, className: "sw-Button sw-Button-controlSub" },
            react_1.default.createElement("i", { className: "fa fa-barcode estimateForm-BarcodeReader_StartButtonIcon" }),
            "\u30D0\u30FC\u30B3\u30FC\u30C9\u304B\u3089\u5546\u54C1\u60C5\u5831\u3092\u8AAD\u307F\u8FBC\u3080"),
        react_1.default.createElement("div", { className: "estimateForm-BarcodeReader_Annotation" },
            "\u203B\u8AAD\u307F\u8FBC\u3093\u3060\u60C5\u5831\u306F\u30D5\u30A9\u30FC\u30E0\u3078\u81EA\u52D5\u5165\u529B\u3055\u308C\u307E\u3059\u3002",
            ((0, get_device_type_1.getDeviceType)() === get_device_type_1.DeviceType.MOBILE_IOS || (0, get_device_type_1.getDeviceType)() === get_device_type_1.DeviceType.TABLET_IOS) &&
                react_1.default.createElement(react_1.default.Fragment, null, "\u30D0\u30FC\u30B3\u30FC\u30C9\u30EA\u30FC\u30C0\u30FC\u306F\u300CSafari\u300D\u3092\u3054\u5229\u7528\u304F\u3060\u3055\u3044\u3002")))));
});
exports.default = BarcodeReader;
